export default __webpack_public_path__ + "static/media/ProfilePhoto.cde189c3.svg";